import {formatMoneyDisplay} from "@corporatesclub/shared";
import {useI18n} from "./I18nProvider";

type Props = {
  lei: number;
  eurRate?: number;
  className?: string;
};

export function MoneyDisplay({lei, eurRate, className}: Props) {
  const {currency, eurRate: ctxRate} = useI18n();
  const text = formatMoneyDisplay(lei, currency, eurRate ?? ctxRate);
  if(className) return <span className={className}>{text}</span>;
  return <>{text}</>;
}
